export default __webpack_public_path__ + "static/media/Email.e42b8c9a.png";